import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Review = () => {
    return (
        <div className="pochtabank-review">
            <FullWrapper>
                <div className="pochtabank-reviewWrapper">
                    <div className="pochtabank-reviewTitle">Клиент о нас</div>
                    <div className="pochtabank-reviewMiddle">
                        Вебпрактик» успешно создали новую версию сайта &laquo;Почта Банк&raquo;. Был
                        обновлен дизайн и&nbsp;разработана современная программная платформа,
                        обеспечивающая интеграцию с&nbsp;внутрибанковскими и&nbsp;внешними
                        системами.<span>»</span>
                    </div>
                    <div className="pochtabank-reviewBottom">
                        <div className="pochtabank-reviewBottomInfo">
                            <div className="pochtabank-reviewBottomAuthor">Павел Куданкин</div>
                            <div className="pochtabank-reviewBottomPosition">
                                Руководитель направления веб-проектов, Почта&nbsp;Банк
                            </div>
                        </div>
                        <img
                            src="/images/svg/new-pochtabank/review-pochtabank.svg"
                            alt="reviewLogo"
                            className="pochtabank-reviewBottomLogo"
                        />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Review;
